import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  commissions: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the commissions
export const fetchCommissions = createAsyncThunk(
  "fetchCommissions/commissions",
  async ({ enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`payments/commissions`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create commission
export const createCommission = createAsyncThunk(
  "createCommission/commissions",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`payments/commissions`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update commission
export const updateCommission = createAsyncThunk(
  "updateCommission/commissions",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `payments/commissions/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete commission
export const deleteCommission = createAsyncThunk(
  "deleteCommission/commissions",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`payments/commissions/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const commissionslice = createSlice({
  name: "commission",
  initialState,
  extraReducers: (builder) => {
    // TODO: create commission
    builder.addCase(fetchCommissions.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchCommissions.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      state.commissions = action.payload;
    });

    builder.addCase(fetchCommissions.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create commission
    builder.addCase(createCommission.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createCommission.fulfilled, (state, action) => {
      state.isLoading = false;
      state.commissions.data = [action.payload.data, ...state.commissions.data];
      state.commissions.meta.total = state.commissions.meta.total + 1;
      action.payload.enqueueSnackbar("Commission is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createCommission.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update commission
    builder.addCase(updateCommission.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateCommission.fulfilled, (state, action) => {
      state.isLoading = false;
      state.commissions.data = state.commissions.data.map((commission) => {
        if (commission.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return commission;
        }
      });
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("Commission is updated successfully.", {
          variant: "success",
        });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateCommission.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(
            action.payload.error ||
              action.payload.error.errors ||
              action.payload.error.message
          ),
          {
            variant: "error",
          }
        );
    });

    // TODO: delete commission
    builder.addCase(deleteCommission.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteCommission.fulfilled, (state, action) => {
      state.isLoading = false;
      state.commissions.data = state.commissions.data.filter(
        (commission) => commission.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Commission is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteCommission.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default commissionslice.reducer;
